// Общий визуальный язык bento-блоков (секция «Результаты рекламодателей»).
// Держим в одном месте, чтобы блоки не разъезжались при правках стиля.

export const ACCENT = 'linear-gradient(180deg, #0d6fe0 0%, #145aff 100%)'

export const CARD = 'rounded-[20px] border border-[#e9e9ec] bg-white'

export const CARD_SHADOW = {
  boxShadow: '0 1px 2px rgba(15,31,61,0.04), 0 6px 16px -8px rgba(15,31,61,0.08)',
}

/** Внешний светлый контейнер bento. */
export function BentoShell({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="w-full rounded-[22px] border border-[#e9e9ec] p-2 sm:rounded-[28px] sm:p-4"
      style={{ background: 'linear-gradient(180deg, #f6f7f9 0%, #f1f2f5 100%)' }}
    >
      {children}
    </div>
  )
}

// IconTile, IconLead и IconAction удалены вместе с переходом карточек кейсов
// на эмодзи: рисованные иконки остались бы единственными на весь сайт.

/** Бледная сетка в правом верхнем углу карточки. */
export function GridPattern() {
  return (
    <div
      className="pointer-events-none absolute right-0 top-0 h-[220px] w-[200px] opacity-[0.55]"
      aria-hidden
      style={{
        backgroundImage:
          'linear-gradient(to right, #eef1f6 1px, transparent 1px), linear-gradient(to bottom, #eef1f6 1px, transparent 1px)',
        backgroundSize: '44px 44px',
        maskImage: 'radial-gradient(120px 120px at 100% 0%, #000 0%, transparent 100%)',
        WebkitMaskImage: 'radial-gradient(120px 120px at 100% 0%, #000 0%, transparent 100%)',
      }}
    />
  )
}

/** Точечный паттерн в правом верхнем углу карточки. */
export function DotPattern() {
  return (
    <div
      className="pointer-events-none absolute right-0 top-0 h-[180px] w-[180px]"
      aria-hidden
      style={{
        backgroundImage: 'radial-gradient(#d8dde6 1.3px, transparent 1.3px)',
        backgroundSize: '10px 10px',
        maskImage: 'radial-gradient(110px 110px at 100% 0%, #000 0%, transparent 100%)',
        WebkitMaskImage: 'radial-gradient(110px 110px at 100% 0%, #000 0%, transparent 100%)',
      }}
    />
  )
}
